import { DateTime } from "luxon"

export default {
  methods: {
    removeTimeZone(datetime) {
      return datetime ? datetime.split(".").slice(0, -1)[0] : dateTime
    },

    setTimeZone(datetime) {
      if (datetime) {
        const indexOfTimeZone = datetime.search(/\+07:00/)
        const splitDatetime = datetime.split(":").slice(0, -1).join(":")

        return indexOfTimeZone > 0
          ? datetime
          : splitDatetime.concat(":00.000+07:00")
      }
      return datetime
    },

    removeSetTimeZone(datetime) {
      return datetime ? datetime.split(":00.000+07:00")[0] : datetime
    },

    setDateTimeFormat(datetime, format) {
      return datetime ? DateTime.fromISO(datetime).toFormat(format) : datetime
    },

    customFormatDateTime(datetime, originFormat, expectedFormat) {
      return datetime
        ? DateTime.fromFormat(datetime, originFormat).toFormat(expectedFormat)
        : datetime
    },

    isAfterNow(dateTime) {
      return DateTime.fromISO(dateTime) > DateTime.now()
    },
  },
}
